import React from 'react';

import './styles.css';
import PageHeader from '../../shared/PageHeader';

function TeacherForm() {
    return (
        <div id="page-teacher-form">
            <PageHeader title="Que incrível que você quer dar aulas."/>
        </div>
    )
}

export default TeacherForm;